import aesjs from "aes-js";

const getKey = function getEncryptionSecretKey() {
  const base64 = process.env.VUE_APP_ENCRYPTION_PASS;
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const decrypt = function AESDecryptHexToStringWithCTRMethod(
  encryptedHex
) {
  const encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);

  const aesCtr = new aesjs.ModeOfOperation.ctr(getKey());
  const decryptedBytes = aesCtr.decrypt(encryptedBytes);

  return aesjs.utils.utf8.fromBytes(decryptedBytes);
};
